import { CircularProgress } from "@chakra-ui/react";
import * as React from "react";
//import { LoadingIndicatorProps } from "react-select/dist/declarations/src/components/indicators";

export const SelectLoadingIndicator = () => {
  return (
    <div>
      <CircularProgress
        color="var(--okhi-spinner-color)"
        isIndeterminate
        size={4}
        mr={2}
      />
    </div>
  );
};
